module.exports = __webpack_public_path__ + "img/public/SiteIcons/sliderPrevArrow.svg?0c17ce5f";